(function($){
  'use strict';

  /*
   * Bind the cookie bar buttons to the functionality
   *
   */

  var $cookiebar = $('#cookie-bar');
  console.log($cookiebar.find('#cookie-accept'));

  if($cookiebar.length) {
    $cookiebar.find('#cookie-accept').on('click', function(e){
      e.preventDefault(); 
      acceptedPolicy(); 
    });

    // $cookiebar.find('.cookie-decline').on('click', function(e){
    //   e.preventDefault(); 
    //   declinedPolicy();
    // });

  }

}(jQuery));
